import { HttpInterceptorFn } from "@angular/common/http"
import { Injectable, signal, computed, inject, effect } from "@angular/core"
import { finalize } from "rxjs"

@Injectable({ providedIn: 'root' })
export class LoadingService {
    private readonly pendingRequests = signal(0)

    readonly longLoadingThreshold = 2000 // milliseconds

    readonly isLongLoading = signal(false)

    readonly isLoading = computed(() => this.pendingRequests() > 0)

    increment(): void {
        this.pendingRequests.update(count => count + 1)
    }

    decrement(): void {
        this.pendingRequests.update(count => Math.max(0, count - 1))
    }

    constructor() {
        let timeoutId: ReturnType<typeof setTimeout> | null = null

        effect((onCleanup) => {
            const loading = this.isLoading()

            if (loading) {
                timeoutId = setTimeout(() => {
                    this.isLongLoading.set(true)
                }, this.longLoadingThreshold)

                onCleanup(() => {
                    if (timeoutId) clearTimeout(timeoutId)
                    this.isLongLoading.set(false)
                })
            } else {
                this.isLongLoading.set(false)
            }
        })
    }
}

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
    const loadingService = inject(LoadingService)

    loadingService.increment()

    return next(req).pipe(
        finalize(() => loadingService.decrement()),
    )
}